import React from 'react'
import MainLayout from 'app/components/MainLayout'
import { Container, Card, CardContent } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import { FormattedMessage } from 'react-intl'
import { PaidPlanAccess } from 'app/auth/paidPlanAccess'
import PaidPlanAccessBlock from 'app/auth/PaidPlanAccessBlock'

const useStyles = makeStyles((theme) => ({
  Header: {
    padding: '1rem 0',
  },
  Content: {
    color: '#404040',
    paddingBottom: '16px !important',
  },
  titleContent: {
    '& .MuiTypography-root': {
      fontSize: '25px',
    },
  },
  descContent: {
    fontSize: '14px',
  },
}))

const Analytics = () => {
  const classes = useStyles()

  return (
    <div className="overflow-auto">
      <MainLayout
        main={
          <Container className="p-0 m-0 overflow-x-hidden" maxWidth={false}>
            <Card>
              <PaidPlanAccess
                freePlanComponent={
                  <div className="m-16">
                    <PaidPlanAccessBlock
                      iconSize="sm"
                      titleId="paidPlanRestriction.analytics.description.text"
                    />
                  </div>
                }
              >
                <CardContent
                  className={clsx(classes.Content, 'text-center px-0')}
                >
                  <div style={{ fontSize: '25px' }}>
                    <FormattedMessage
                      id="analytics.title"
                      values={{
                        b: (text) => <b>{text}</b>,
                      }}
                    />
                  </div>
                  <div
                    className="pt-2 pb-5 font-bold"
                    style={{ fontSize: '25px' }}
                  >
                    <FormattedMessage id="analytics.header" />
                  </div>
                  <div style={{ fontSize: '14px' }}>
                    <FormattedMessage id="analytics.content1" />
                  </div>

                  <div style={{ fontSize: '14px' }}>
                    <FormattedMessage id="analytics.content2" />
                  </div>
                  <div
                    className={clsx(classes.Header)}
                    style={{ fontSize: '14px' }}
                  >
                    <FormattedMessage id="analytics.content3" />
                  </div>
                  <div className="font-bold" style={{ fontSize: '25px' }}>
                    <FormattedMessage id="analytics.bottom" />
                  </div>
                </CardContent>
              </PaidPlanAccess>
            </Card>

            <Card className="mt-24">
              <img
                className="max-w-full m-auto h-auto block"
                src="assets/images/analytics/analytics1@3x.png"
                alt="analytic"
              />
            </Card>
          </Container>
        }
      />
    </div>
  )
}

export default Analytics
